import React from 'react';
import { Filter, Calendar, Activity } from 'lucide-react';

/**
 * AdFilters - Filter bar for competitor ads
 */
const AdFilters = ({
  status,
  setStatus,
  platform,
  setPlatform,
  sortBy,
  setSortBy,
  dateRange,
  setDateRange
}) => {
  const selectStyle = {
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    fontSize: '13px',
    color: '#374151',
    backgroundColor: '#fff',
    cursor: 'pointer',
    outline: 'none',
    minWidth: '140px'
  };

  const labelStyle = {
    fontSize: '12px',
    color: '#6b7280',
    marginBottom: '4px',
    display: 'block'
  };

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      gap: '16px',
      padding: '16px',
      backgroundColor: '#f9fafb',
      borderRadius: '12px',
      marginBottom: '20px'
    }}>
      {/* Status filter */}
      <div>
        <label style={labelStyle}>
          <Activity size={12} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
          Statut
        </label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={selectStyle}
        >
          <option value="all">Toutes</option>
          <option value="active">Actives</option>
          <option value="stopped">Stoppées</option>
        </select>
      </div>

      {/* Platform filter */}
      <div>
        <label style={labelStyle}>
          <Filter size={12} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
          Plateforme
        </label>
        <select
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
          style={selectStyle}
        >
          <option value="">Toutes</option>
          <option value="facebook">Facebook</option>
          <option value="instagram">Instagram</option>
          <option value="messenger">Messenger</option>
        </select>
      </div>

      {/* Sort by */}
      <div>
        <label style={labelStyle}>
          Trier par
        </label>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          style={selectStyle}
        >
          <option value="startTime">Date de diffusion</option>
          <option value="creationTime">Date de création</option>
          <option value="lastSeen">Dernière vue</option>
          <option value="longevity">Longévité</option>
          <option value="reach">Reach EU</option>
        </select>
      </div>

      {/* Date range */}
      <div>
        <label style={labelStyle}>
          <Calendar size={12} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
          Période
        </label>
        <select
          value={dateRange}
          onChange={(e) => setDateRange(e.target.value)}
          style={selectStyle}
        >
          <option value="0">Aujourd'hui</option>
          <option value="1">Hier</option>
          <option value="7">7 derniers jours</option>
          <option value="14">14 derniers jours</option>
          <option value="30">30 derniers jours</option>
          <option value="90">90 derniers jours</option>
          <option value="">Tout</option>
        </select>
      </div>
    </div>
  );
};

export default AdFilters;
